import { createAsyncThunk, createSlice, PayloadAction} from "@reduxjs/toolkit"
import {
    DirectOffer, DirectOfferVariant,
} from "../../types"
import {getDirectOffersByAccommodation, postDirectOffer} from "../../shared/queries"
import dayjs from "dayjs";
import {parseInt} from "lodash";
import {generateUUID} from "../../shared/utils";

type BeDirectState = {
    offers: DirectOffer[],
    currentOffer?: DirectOffer,
    fetching: {
        offers: boolean,
        createOffer: boolean
    }
}

export const fetchOffers = createAsyncThunk(
    'beDirect/fetchOffers',
    async ({ idAccomodation } : { idAccomodation: number | string | null }, { getState }) => {
        if (idAccomodation) return await getDirectOffersByAccommodation(idAccomodation)
        return []
    }
)

export const storeOffer = createAsyncThunk(
    'beDirect/storeOffer',
    async ({ offer } : { offer: DirectOffer }, { getState }) => {
        return await postDirectOffer(offer)
    }
)


const offerSlice = createSlice({
    name: 'beDirectSlice',
    initialState: {
        fetching: {
            offers: false,
            createOffer: false
        },
        offers: [],
        currentOffer: undefined,
    } as BeDirectState,
    reducers: {
        initOffer: (state, action: PayloadAction<number | string>) => {
            state.currentOffer = {
                accomodation: {
                    idAccomodation: parseInt(action.payload.toString())
                },
                published: false,
                title: '',
                variants: [
                    {
                        localId: generateUUID(),
                        coverUrl: '',
                        title: '',
                        ctaLink: '',
                        languages: [],
                        bullets: [
                            {
                                bulletOrder: 0,
                                content: ''
                            }
                        ]
                    }
                ],
                startDate: dayjs().format('2025-01-01'),
                endDate: dayjs().add(1, 'year').format('2025-01-02')
            }
        },
        setCurrentOffer: (state, action: PayloadAction<DirectOffer>) => {
            state.currentOffer = action.payload
        },
        updateCurrentOffer: (state, action: PayloadAction<DirectOffer>) => {
            state.currentOffer = {
                ...state.currentOffer,
                ...action.payload
            }
        },
        addVariant: (state, action: PayloadAction<DirectOfferVariant>) => {
            if (state.currentOffer) {
                state.currentOffer.variants.push(action.payload)
            }
        },
        updateVariant: (state, action: PayloadAction<DirectOfferVariant>) => {
            if (state.currentOffer) {
                state.currentOffer.variants = state.currentOffer.variants.map(v => {
                    if (v.idBeDirectOfferVariant && v.idBeDirectOfferVariant === action.payload.idBeDirectOfferVariant) {
                        return action.payload
                    }

                    if (v.localId && v.localId === action.payload.localId) {
                        return action.payload
                    }

                    return v
                })
            }
        }
    },
    extraReducers: builder => {
        builder.addCase(fetchOffers.pending, (state) => {
            state.fetching.offers = true
        })
        builder.addCase(fetchOffers.rejected, (state) => {
            state.fetching.offers = false
        })
        builder.addCase(fetchOffers.fulfilled, (state, action: PayloadAction<DirectOffer[]>) => {
            state.offers = action.payload
            state.fetching.offers = false
        })

        builder.addCase(storeOffer.pending, (state) => {
            state.fetching.createOffer = true
        })
        builder.addCase(storeOffer.rejected, (state) => {
            state.fetching.createOffer = false
        })
        builder.addCase(storeOffer.fulfilled, (state, action: PayloadAction<DirectOffer>) => {
            state.fetching.createOffer = false
            state.currentOffer = action.payload
        })
    }
})

export const {
    initOffer,
    updateCurrentOffer,
    updateVariant,
    setCurrentOffer
} = offerSlice.actions

export default offerSlice.reducer
